// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"63":"191288b3","109":"cb80b445","664":"1b3f2f37","900":"a19a2789"}[chunkId] + ".chunk.css";
};